export class CustomAgendaTaskVariant {
	public index;

	constructor(obj) {
		this.index = obj.index;
	}
} 
